import {
  CreateMessageData,
  RequestMessagesByChatId,
  ResponseMessagesWithMeta
} from "@sms/shared/message/message.interface";

import { socketMessages } from "./messages.socket";

const fetchMessages: (chatId: string) => Promise<ResponseMessagesWithMeta> = async chatId => {
  return (await socketMessages.emitWithAck("fetchMessagesChat", {
    chatId
  })) as ResponseMessagesWithMeta;
};

const fetchMessagesNextPage: (data: RequestMessagesByChatId) => Promise<ResponseMessagesWithMeta> = async (
  data: RequestMessagesByChatId
) => {
  return (await socketMessages.emitWithAck("handleFetchMessagesNextPage", data)) as ResponseMessagesWithMeta;
};

const sendMessage: (data: CreateMessageData) => void = (data: CreateMessageData) => {
  socketMessages.emit("createMessage", data);
};

export default {
  fetchMessages,
  fetchMessagesNextPage,
  sendMessage
};
